function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "asterisk"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12 2c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 11h-2.268l1.134-1.964c.276-.479.112-1.09-.366-1.366s-1.09-.112-1.366.366l-1.134 1.964-1.134-1.964c-.277-.479-.889-.643-1.366-.366-.479.276-.642.888-.366 1.366l1.134 1.964h-2.268c-.552 0-1 .447-1 1s.448 1 1 1h2.268l-1.134 1.965c-.276.479-.112 1.09.366 1.366.158.091.33.134.499.134.346 0 .682-.18.867-.5l1.134-1.965 1.134 1.965c.186.321.521.5.867.5.17 0 .342-.043.499-.134.479-.276.643-.888.366-1.366l-1.134-1.965h2.268c.553 0 1-.447 1-1s-.447-1-1-1z"
})));

var Svg011Asterisk = function Svg011Asterisk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg011Asterisk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/011-asterisk.d36613c3.svg";
export { ForwardRef as ReactComponent };